import api from './api';

export interface BaselineConsent {
  member_id: number;
  opted_in: boolean;
  consent_at: string | null;
}

export interface MetricPercentiles {
  p10: number | null;
  p50: number | null;
  p90: number | null;
  sample_count: number;
  mean?: number;
}

export interface MemberSafetyBaseline {
  member_id: number;
  pool_id: number;
  wearable_id: number | null;
  consent: BaselineConsent;
  metrics: Record<string, MetricPercentiles | string>;
  snapshot_fallback?: Record<string, string> | null;
  pilot?: boolean;
}

export async function fetchSafetyBaseline(
  poolId: number,
  memberId: number,
): Promise<MemberSafetyBaseline> {
  return api.get<MemberSafetyBaseline>(
    `/api/pools/${poolId}/members/${memberId}/safety-baseline`,
  );
}

export async function setBaselineConsent(
  poolId: number,
  memberId: number,
  optedIn: boolean,
): Promise<{ consent: BaselineConsent; baseline: MemberSafetyBaseline }> {
  return api.put<{ consent: BaselineConsent; baseline: MemberSafetyBaseline }>(
    `/api/pools/${poolId}/members/${memberId}/safety-baseline/consent`,
    null,
    { params: { opted_in: optedIn } },
  );
}
